module.exports = __webpack_public_path__ + "media/src/img/small_heart-dc8687d54aa1d9e726eba01021ad6001.png";